import { Component } from '@angular/core';

@Component({
  selector: 'app-branding',
  template: `
    <div class="branding">
      <a href="/" class="brand-title__link">
        <span class="brand-title__sidebar">Phần mềm Chỉnh lý và Số hoá tài liệu</span>
      </a>
    </div>
  `,
  styles: [
    `
      .brand-title__link {
        text-decoration: none;
        display: block;
        padding: 8px 0;
      }
      .brand-title__sidebar {
        display: block;
        color: #1f2a44;
        font-family: 'Roboto', sans-serif;
        font-size: 15px;
        font-weight: 600;
        line-height: 1.35;
        text-align: left;
        word-break: break-word;
      }
    `,
  ],
})
export class BrandingComponent {
  constructor() {}
}
